module.exports = __webpack_public_path__ + "img/zhuakuang.f24d53de.gif";